import {createFeatureSelector} from "@ngrx/store";

import * as fromUserContext from './userContextStore/context.reducers';
import * as fromGeneral from '../pages/general.reducers';

export interface AppState {
    general: fromGeneral.IGeneralState,
    userContext: fromUserContext.UserContext,
}

export const reducers = {
    general: fromGeneral.reducer,
    userContext: fromUserContext.reducer,
}

export const selectUserContextState = createFeatureSelector<fromUserContext.UserContext>('userContext');

export const selectGeneralState = createFeatureSelector<fromGeneral.IGeneralState>('general');

